import { WIPPanel } from "../../components/WIPPanel";
import { PlayersIcon } from "../../components/icons";

export function PlayersTab() {
  return (
    <WIPPanel
      icon={<PlayersIcon />}
      title="Player management is coming in a future version"
      description="This section will show which players are currently in this server and let you manage them. It does not do anything yet."
    />
  );
}
